// DROP THIS FILE anywhere in your project temporarily
// Import it ONCE in App.jsx:  import './debugChatUnread';
// Then open browser console and watch the logs when a message is sent.

import webSocketService from './WebSocketService';
import { getCounts, getOpenProjectId, subscribe } from './chatUnreadStore';

console.log('%c[DEBUG] chatUnread debug script loaded', 'color: orange; font-weight: bold');

// 1. Check WebSocket connection state right now
console.log('[DEBUG] WS connected?', webSocketService.isConnected());
console.log('[DEBUG] WS status:', webSocketService.getConnectionStatus());
console.log('[DEBUG] WS info:', webSocketService.getConnectionInfo());

// 2. Check current store state
console.log('[DEBUG] store counts NOW:', getCounts());
console.log('[DEBUG] store openProjectId NOW:', getOpenProjectId());

// 3. Subscribe to store — log every change
subscribe(() => {
  console.log('%c[DEBUG] store CHANGED → counts:', 'color: green; font-weight: bold', getCounts());
  console.log('%c[DEBUG] store CHANGED → openProjectId:', 'color: green', getOpenProjectId());
});

// 4. Directly intercept chatNewMessage WebSocket event
webSocketService.on('chatNewMessage', (data) => {
  console.log('%c[DEBUG] chatNewMessage RAW EVENT:', 'color: blue; font-weight: bold', JSON.stringify(data, null, 2));
  console.log('[DEBUG] data.projectId:', data?.projectId);
  console.log('[DEBUG] data.message?.senderId:', data?.message?.senderId);
  console.log('[DEBUG] data.message?.messageId:', data?.message?.messageId);
  console.log('[DEBUG] data.message?.mentions:', data?.message?.mentions);
});

// 5. Watch ALL WebSocket messages (raw)
const origHandleMessage = webSocketService._handleMessage?.bind(webSocketService);
if (origHandleMessage) {
  webSocketService._handleMessage = function(data) {
    try {
      const parsed = JSON.parse(data);
      if (parsed.type !== 'heartbeat' && parsed.type !== 'ping') {
        console.log('%c[DEBUG] RAW WS message:', 'color: purple', parsed.type, parsed);
      }
    } catch {}
    return origHandleMessage(data);
  };
  console.log('[DEBUG] _handleMessage intercepted successfully');
} else {
  console.warn('[DEBUG] Could not intercept _handleMessage — method not found');
}

// 6. Log localStorage keys relevant to auth
const sessionData = (() => { try { return JSON.parse(localStorage.getItem('sessionData') || '{}'); } catch { return {}; } })();
const token       = (() => { try { return JSON.parse(localStorage.getItem('token') || '{}'); } catch { return {}; } })();
console.log('[DEBUG] sessionData.userId:', sessionData?.userId);
console.log('[DEBUG] token.userId:', token?.userId);
console.log('[DEBUG] All localStorage keys:', Object.keys(localStorage));

export {};